import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import { resetDagState, setFilter } from '../../../../redux/actions/dagActions';
import { logoutUser } from '../../../../redux/actions/authActions';
import { Theme } from '../../../../utils/Theme';
import Header from '../../../layout/Partials/Header';
import AccessDenied from '../../../common/AccessDenied';
import TextAreaFieldGroup from '../../../common/TextAreaFieldGroup';
import TextFieldGroup from '../../../common/TextFieldGroup';
import {
    getQlikApps,
    getQlikStreams,
} from '../../../../redux/actions/qlikActions';
import AdminLayout from '../../../layout/AdminLayout';

import { withRouter } from 'react-router-dom';

const styles = Theme();

class CreateFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //Form inputs
            title: '',
            description: '',
            loading: true,
            inputErrors: {},
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentWillUnmount() {
        this.props.resetDagState();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let { title, description, inputErrors, loading } = prevState;

        if (nextProps.dag && !nextProps.dag.loading) {
            if (nextProps.dag.errors) {
                inputErrors = nextProps.dag.errors;
            }
            loading = false;
        }

        return { title, description, inputErrors, loading };
    }

    onSubmit(event) {
        event.preventDefault();
        const { title, description } = this.state;
        const filter = { title, description };
        this.props.setFilter(filter, this.props.history);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        const { classes, auth, history } = this.props;
        const { title, description, inputErrors } = this.state;

        return (
            <AdminLayout>
                <div className="o-page">
                    <Header>
                        <h2 className="c-navbar__title">New Filter </h2>
                    </Header>
                    {!auth.isAuthenticated && auth.user.role !== 'Admin' ? (
                        <AccessDenied props={{ classes, history }} />
                    ) : (
                        <div className="container">
                            <div className={'row'}>
                                <div className="col-md-12 col-xl-12 u-pr-zero u-pt-zero ">
                                    <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                                        <div className="u-m-auto">
                                            <div className="c-card u-p-zero u-m-zero">
                                                <div className="o-line c-card__title u-p-small u-m-small">
                                                    <h4
                                                        className={`c-card__title ${classes.colorSecondary}`}
                                                    >
                                                        New Dynamic Application
                                                        Generation Filter
                                                    </h4>
                                                    <button
                                                        className={`c-btn ${classes.buttonSecondary}`}
                                                        onClick={() => {
                                                            this.props.history.goBack();
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                                <div
                                                    className={
                                                        'c-card__body u-pb-small'
                                                    }
                                                >
                                                    <form
                                                        noValidate
                                                        onSubmit={this.onSubmit}
                                                        autoComplete={'none'}
                                                    >
                                                        <div
                                                            className={
                                                                'row u-m-small'
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    'col-6'
                                                                }
                                                            >
                                                                <TextFieldGroup
                                                                    label="Filter Title"
                                                                    type="text"
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        title
                                                                    }
                                                                    name="title"
                                                                    placeholder="e.g. Supplier"
                                                                    info={
                                                                        'Filter name e.g. Supplier or Customer'
                                                                    }
                                                                    error={
                                                                        inputErrors.title
                                                                    }
                                                                />
                                                            </div>

                                                            <div
                                                                className={
                                                                    'col-12'
                                                                }
                                                            >
                                                                <TextAreaFieldGroup
                                                                    label={
                                                                        'Filter Description'
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    name={
                                                                        'description'
                                                                    }
                                                                    value={
                                                                        description
                                                                    }
                                                                    error={
                                                                        inputErrors.description
                                                                    }
                                                                />
                                                            </div>

                                                            <div
                                                                className={
                                                                    'col-12 u-mt-medium'
                                                                }
                                                            >
                                                                <button
                                                                    className={`c-btn ${classes.buttonPrimary}`}
                                                                >
                                                                    Create
                                                                    Filter
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </AdminLayout>
        );
    }
}

CreateFilter.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    resetDagState: PropTypes.func,
    getQlikApps: PropTypes.func.isRequired,
    getQlikStreams: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object,
    dag: PropTypes.object,
    qlik: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    qlik: state.qlik,
    dag: state.dag,
});

export default connect(mapStateToProps, {
    getQlikApps,
    getQlikStreams,
    resetDagState,
    logoutUser,
    setFilter,
})(withStyles(styles)(withRouter(CreateFilter)));
